module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/i18next-browser-languagedetector/index.js
// module id = 218
// module chunks = 0 1 2 3